/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ImgUploadInput.vue?vue&type=template&id=3a8d9b10&scoped=true&lang=html&"
import script from "./ImgUploadInput.vue?vue&type=script&lang=js&"
export * from "./ImgUploadInput.vue?vue&type=script&lang=js&"
import style0 from "./ImgUploadInput.vue?vue&type=style&index=0&id=3a8d9b10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8d9b10",
  null
  
)

export default component.exports